import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  {
    q: "Web sitesi teslim süresi ne kadardır?",
    a: "Projenin kapsamına göre değişmekle birlikte, standart kurumsal siteler ortalama 7-14 iş günü içerisinde teslim edilmektedir. E-ticaret ve özel yazılım gerektiren projeler 3-6 hafta arasında sürmektedir.",
  },
  {
    q: "Reklam bütçemi nasıl belirlemeliyim?",
    a: "Sektörünüze, hedeflerinize ve rekabet durumuna göre size en uygun bütçe planlamasını ücretsiz analiz toplantımızda birlikte belirliyoruz. Genellikle aylık 3.000 TL'den başlayan bütçelerle anlamlı sonuçlar alabilirsiniz.",
  },
  {
    q: "Randevu ve sipariş sistemleri nasıl çalışıyor?",
    a: "Müşterileriniz web siteniz veya WhatsApp üzerinden 7/24 işlem yapabilir. Tüm süreci tek bir yönetici panelinden veya cep telefonunuzdan takip edebilirsiniz. Otomatik hatırlatma SMS / WhatsApp mesajları gönderilebilir.",
  },
  {
    q: "Aylık rapor ve takip nasıl yapılıyor?",
    a: "Her ay başında size detaylı bir performans raporu sunuyoruz. Reklam harcamalarınız, dönüşüm sayıları, ROAS değerleri ve bir sonraki aya yönelik aksiyonları içeren bu raporu birlikte değerlendiriyoruz.",
  },
  {
    q: "Mevcut web sitemi yenileyebilir misiniz?",
    a: "Evet. Var olan sitenizi inceleyip eksikleri analiz ediyor, isterseniz tamamen yenileyebilir ya da kademeli iyileştirmeler yapabiliriz. Domain ve içeriklerinizi koruyarak da bu işlemi gerçekleştirebiliriz.",
  },
  {
    q: "Sözleşme ve ödeme koşullarınız nedir?",
    a: "Tüm projelerimizde resmi sözleşme imzalıyoruz. Tek seferlik projelerde %50 başlangıç, %50 teslim sonrası; aylık hizmetlerde ise her ay başında ödeme tercih ediyoruz. Ayrıntılar için iletişime geçebilirsiniz.",
  },
];

export default function FAQ() {
  return (
    <section
      id="sss"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="ab-chip">SSS</span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[var(--ab-navy)] leading-[1.05]">
            Sıkça sorulan <span className="ab-text-gradient">sorular</span>.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Aklınıza takılanları aşağıdan bulabilir, daha fazla detay için
            WhatsApp&apos;tan yazabilirsiniz.
          </p>
        </div>

        <div className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-slate-200 bg-white hover:border-[var(--ab-blue)]/40 transition-colors px-5 sm:px-6 data-[state=open]:border-[var(--ab-blue)]/50 data-[state=open]:shadow-[0_18px_38px_-22px_rgba(45,63,255,0.25)]"
              >
                <AccordionTrigger className="text-left font-display font-semibold text-[var(--ab-navy)] text-base sm:text-lg hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
